module.exports = {
  getLinkToArticleByArticleTitle: function (articleTitle) {
    return "/stories/" + articleTitle.toLowerCase().replace(/[ ]/g, "-")
  },
}
